var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
  stroke: "currentColor",
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.454 7.56s.039-.796.89-1.48c.505-.407 1.11-.525 1.656-.533.497-.007.94.076 1.206.202.454.216 1.34.745 1.34 1.868 0 1.182-.773 1.718-1.654 2.309-.88.59-1.12 1.231-1.12 1.893",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.855 14.844a.786.786 0 1 0 0-1.57.786.786 0 0 0 0 1.57Z",
  fill: "currentColor"
})));
export { SvgHelp as ReactComponent };